import React from 'react'
import styled from '@emotion/styled'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'
import {Placement} from '@vio/core/src/deepLinking/types'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const GetTheAppWrapper = styled(Button)`
  padding: ${cssTheme.layout.spacing.s300};
  flex-shrink: 0;
`

const GetTheAppText = styled.span`
  color: ${cssTheme.colors.content.brand.primary};
`

interface GetTheAppProps {
  dataId: string
  placement: Placement
}

export const GetTheApp = ({dataId, placement}: GetTheAppProps) => {
  const showOverlay = useShowOverlay()

  const showGetTheAppPopup = () => {
    showOverlay({
      type: OverlayType.Web2AppPopup,
      params: {
        placement
      }
    })
  }

  return (
    <GetTheAppWrapper
      size="md"
      variant="tertiary"
      isRounded
      dataId={dataId}
      iconStart={<Icon name="Iphone" colorPath="content.brand.primary" />}
      onClick={showGetTheAppPopup}
    >
      <GetTheAppText>
        <FormattedMessageWrapper
          id="appBanner.button"
          defaultMessage="Get the app"
        />
      </GetTheAppText>
    </GetTheAppWrapper>
  )
}
